export type LogoMarkProps = {
  width?: number
}

export function LogoMark({ width = 45 }: LogoMarkProps) {
  return (
    <svg
      width={width}
      viewBox="0 0 1440 1440"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Media Matters</title>
      <foreignObject x="-4" y="-4" width="1448" height="1448">
        <div
          style={{
            backdropFilter: "blur(2px)",
            clipPath: "url(#bgblur_0_26_31_clip_path)",
            height: "100%",
            width: "100%",
          }}
        />
      </foreignObject>
      <path
        data-figma-bg-blur-radius="4"
        d="M0 1340C0 1395.23 44.7715 1440 100 1440H1340C1395.23 1440 1440 1395.23 1440 1340V99.9999C1440 44.7714 1395.23 -4.29153e-05 1340 -4.29153e-05H100C44.7715 -4.29153e-05 0 44.7715 0 100V1340Z"
        fill="url(#paint0_linear_26_31)"
        fillOpacity="0.15"
      />
      <path
        d="M1159.29 338.011L1210.56 1094.55C1212.62 1124.91 1188.55 1150.67 1158.12 1150.67H1025.05C997.366 1150.67 974.426 1129.2 972.601 1101.57L950.722 770.314C949.847 757.05 931.336 754.678 927.144 767.292L811.723 1114.68C804.583 1136.17 784.484 1150.67 761.84 1150.67H677.844C655.2 1150.67 635.1 1136.17 627.961 1114.68L512.537 767.292C508.347 754.676 489.835 757.049 488.959 770.312L467.08 1101.57C465.256 1129.2 442.317 1150.67 414.631 1150.67H281.567C251.137 1150.67 227.065 1124.91 229.123 1094.55L280.394 338.011C282.263 310.423 305.185 289 332.838 289H510.297C532.404 289 552.147 302.831 559.7 323.607L706.685 727.971C711.986 742.56 732.624 742.535 737.893 727.937L883.777 323.72C891.296 302.886 911.069 289 933.22 289H1106.85C1134.5 289 1157.42 310.423 1159.29 338.011Z"
        fill="#00FFCC"
      />
      <defs>
        <clipPath id="bgblur_0_26_31_clip_path" transform="translate(4 4)">
          <path d="M0 1340C0 1395.23 44.7715 1440 100 1440H1340C1395.23 1440 1440 1395.23 1440 1340V99.9999C1440 44.7714 1395.23 -4.29153e-05 1340 -4.29153e-05H100C44.7715 -4.29153e-05 0 44.7715 0 100V1340Z" />
        </clipPath>
        <linearGradient
          id="paint0_linear_26_31"
          x1="341"
          y1="-4.90008e-05"
          x2="1312.5"
          y2="1440"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
      </defs>
    </svg>
  )
}

export type LogoProps = {
  width?: number
}

export function Logo({ width = 100 }: LogoProps) {
  return (
    <svg
      width={width}
      viewBox="0 0 3222 650"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Media Matters</title>
      <foreignObject x="-4" y="-4" width="658" height="658">
        <div
          style={{
            backdropFilter: "blur(2px)",
            clipPath: "url(#bgblur_0_26_5_clip_path)",
            height: "100%",
            width: "100%",
          }}
        />
      </foreignObject>
      <path
        data-figma-bg-blur-radius="4"
        d="M0 600C0 627.614 22.3858 650 50 650H600C627.614 650 650 627.614 650 600V50C650 22.3857 627.614 -3.09944e-05 600 -3.09944e-05H50C22.3858 -3.09944e-05 0 22.3857 0 50V600Z"
        fill="url(#paint0_linear_26_5)"
        fillOpacity="0.15"
      />
      <path
        d="M513.466 161.045L535.481 485.903C536.365 498.939 526.028 510 512.962 510H455.824C443.935 510 434.085 500.779 433.301 488.916L423.906 346.675C423.531 340.98 415.582 339.961 413.782 345.378L364.22 494.546C361.155 503.773 352.524 510 342.801 510H306.733C297.01 510 288.379 503.773 285.313 494.546L235.751 345.378C233.951 339.961 226.002 340.98 225.626 346.675L216.231 488.916C215.448 500.779 205.598 510 193.71 510H136.572C123.506 510 113.169 498.939 114.053 485.903L136.068 161.045C136.871 149.199 146.714 140 158.588 140H234.789C244.281 140 252.759 145.939 256.002 154.86L319.117 328.494C321.393 334.758 330.256 334.748 332.518 328.479L395.16 154.909C398.389 145.962 406.88 140 416.391 140H490.947C502.82 140 512.663 149.199 513.466 161.045Z"
        fill="#00FFCC"
      />
      <path
        d="M1078.93 199.594V441.971H1024.48V292.681L961.955 441.971H924.72L862.546 293.383V441.971H808.098V199.594H878.353L943.69 356.964L1009.38 199.594H1078.93Z"
        fill="white"
      />
      <path
        d="M1158.64 334.834H1241.54C1236.27 315.162 1219.76 302.867 1200.09 302.867C1180.06 302.867 1164.61 315.162 1158.64 334.834ZM1295.28 368.907H1158.28C1163.91 388.93 1179.71 401.576 1201.14 401.576C1218.35 401.576 1232.76 393.846 1238.73 383.66H1293.17C1280.18 420.895 1244.7 446.187 1200.09 446.187C1144.94 446.187 1103.49 405.79 1103.49 352.396C1103.49 299.005 1144.94 258.608 1200.09 258.608C1254.89 258.608 1296.68 298.651 1296.68 353.099C1296.68 357.665 1296.34 364.691 1295.28 368.907Z"
        fill="white"
      />
      <path
        d="M1464.95 352.396C1464.95 327.107 1446.33 308.137 1421.04 308.137C1396.1 308.137 1377.48 327.107 1377.48 352.396C1377.48 377.688 1396.1 396.657 1421.04 396.657C1446.33 396.657 1464.95 377.688 1464.95 352.396ZM1516.23 189.056V441.971H1464.95V422.3C1451.6 437.053 1432.98 446.187 1410.85 446.187C1361.68 446.187 1324.44 405.79 1324.44 352.396C1324.44 299.005 1361.68 258.608 1410.85 258.608C1432.98 258.608 1451.6 267.74 1464.95 282.494V189.056H1516.23Z"
        fill="white"
      />
      <path
        d="M1554.95 262.823H1606.23V441.972H1554.95V262.823ZM1548.97 208.376C1548.97 190.46 1562.67 177.113 1580.59 177.113C1598.86 177.113 1612.56 190.46 1612.56 208.376C1612.56 226.642 1598.86 239.99 1580.59 239.99C1562.67 239.99 1548.97 226.642 1548.97 208.376Z"
        fill="white"
      />
      <path
        d="M1773.6 352.396C1773.6 327.107 1754.98 308.137 1729.69 308.137C1704.75 308.137 1686.13 327.107 1686.13 352.396C1686.13 377.688 1704.75 396.657 1729.69 396.657C1754.98 396.657 1773.6 377.688 1773.6 352.396ZM1824.88 262.824V441.971H1773.6V422.3C1760.25 437.053 1741.63 446.187 1719.5 446.187C1670.32 446.187 1633.09 405.79 1633.09 352.396C1633.09 299.005 1670.32 258.608 1719.5 258.608C1741.63 258.608 1760.25 267.74 1773.6 282.494V262.824H1824.88Z"
        fill="white"
      />
      <path
        d="M2206.41 199.594V441.971H2151.96V292.681L2089.44 441.971H2052.2L1990.03 293.383V441.971H1935.58V199.594H2005.84L2071.17 356.964L2136.86 199.594H2206.41Z"
        fill="white"
      />
      <path
        d="M2374.2 352.396C2374.2 327.107 2355.59 308.137 2330.3 308.137C2305.36 308.137 2286.74 327.107 2286.74 352.396C2286.74 377.688 2305.36 396.657 2330.3 396.657C2355.59 396.657 2374.2 377.688 2374.2 352.396ZM2425.49 262.824V441.971H2374.2V422.3C2360.86 437.053 2342.24 446.187 2320.11 446.187C2270.93 446.187 2233.7 405.79 2233.7 352.396C2233.7 299.005 2270.93 258.608 2320.11 258.608C2342.24 258.608 2360.86 267.74 2374.2 282.494V262.824H2425.49Z"
        fill="white"
      />
      <path
        d="M2664.47 262.823V210.132L2613.18 221.373V262.823H2582.43H2580.51H2547.65V210.132L2496.37 221.373V262.823H2463.7V309.542H2496.37V441.972H2547.65V309.542H2580.51H2582.43H2613.18V441.972H2664.47V309.542H2699.24V262.823H2664.47Z"
        fill="white"
      />
      <path
        d="M2774.7 334.834H2857.6C2852.33 315.162 2835.82 302.867 2816.15 302.867C2796.13 302.867 2780.67 315.162 2774.7 334.834ZM2911.34 368.907H2774.35C2779.97 388.93 2795.77 401.576 2817.2 401.576C2834.41 401.576 2848.82 393.846 2854.79 383.66H2909.24C2896.24 420.895 2860.76 446.187 2816.15 446.187C2761 446.187 2719.55 405.79 2719.55 352.396C2719.55 299.005 2761 258.608 2816.15 258.608C2870.95 258.608 2912.75 298.651 2912.75 353.099C2912.75 357.665 2912.4 364.691 2911.34 368.907Z"
        fill="white"
      />
      <path
        d="M3051.51 260.013V312.703C3019.19 312.703 3001.63 330.619 3001.63 358.369V441.971H2950.34V262.824H3001.63V286.71C3014.62 269.85 3031.48 260.013 3051.51 260.013Z"
        fill="white"
      />
      <path
        d="M3082.45 387.524H3133.73C3133.73 397.359 3142.16 405.44 3152.7 405.44C3162.54 405.44 3170.27 399.468 3170.27 391.739C3170.27 380.498 3156.21 375.23 3141.46 372.069C3114.41 365.745 3084.91 352.046 3084.91 315.162C3084.91 278.279 3116.17 258.608 3151.65 258.608C3190.29 258.608 3219.09 283.548 3219.09 314.812H3167.81C3167.81 306.38 3160.78 299.355 3151.3 299.355C3142.87 299.355 3136.19 304.976 3136.19 311.65C3136.19 321.836 3148.49 327.456 3166.05 331.673C3193.1 338.346 3221.55 350.993 3221.55 387.173C3221.55 424.759 3190.29 446.187 3152.35 446.187C3111.95 446.187 3082.45 419.841 3082.45 387.524Z"
        fill="white"
      />
      <defs>
        <clipPath id="bgblur_0_26_5_clip_path" transform="translate(4 4)">
          <path d="M0 600C0 627.614 22.3858 650 50 650H600C627.614 650 650 627.614 650 600V50C650 22.3857 627.614 -3.09944e-05 600 -3.09944e-05H50C22.3858 -3.09944e-05 0 22.3857 0 50V600Z" />
        </clipPath>
        <linearGradient
          id="paint0_linear_26_5"
          x1="163"
          y1="1.19355e-05"
          x2="525"
          y2="650"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#999999" />
        </linearGradient>
      </defs>
    </svg>
  )
}
